export default __webpack_public_path__ + "static/locale-mobile-2f35624aba009ea85fc0c536d114eb57.png";